export default __webpack_public_path__ + "static/media/beaNYU.1df86373.jpg";